import { useQuery } from "@tanstack/react-query";
import { TaskListRwo } from "../types/dailyTaskRwo";
import { getDailyTaskListRwo } from "../api/tasks";

export interface Filters {
  page: number;
  date?: string; // YYYY-MM-DD
  employee_id?: number;
}

export const rwoTaskListKeys = {
  all: ["hr-daily-task-rwo-list"] as const,
  list: (filters: Filters) =>
    [...rwoTaskListKeys.all, "list", filters.page, filters.date] as const,
};

export interface ApiResponse {
  page: number;
  pagesize: number;
  rwo_daily_trackers: TaskListRwo[];
  total: number;
}

export const useRwoTaskList = (filters: Filters) => {
  return useQuery<ApiResponse>({
    queryKey: rwoTaskListKeys.list(filters),
    queryFn: () => getDailyTaskListRwo(filters),
    staleTime: 1000 * 60 * 60 * 3,
    gcTime: 1000 * 60 * 60 * 3,
    refetchOnWindowFocus: true,
  });
};
